export default function Logo({ light = false, showTagline = true }) {
  // Logo is intentionally consistent across light & dark surfaces:
  // - tile color, tile glyph, and the "Tech" accent word never change.
  // - only the primary "Contentium" word and tagline adapt for readability.
  const wordPrimary = light ? "text-white" : "text-[#0A0A0A]";
  const taglineColor = light ? "text-slate-400" : "text-slate-500";

  return (
    <span className="flex items-center gap-3" data-testid="brand-logo">
      <span
        className="grid h-12 w-12 place-items-center bg-[#0A0A0A] font-mono text-lg font-bold leading-none text-white md:h-14 md:w-14 md:text-xl"
        aria-hidden="true"
        style={{ fontFamily: "'Source Code Pro', ui-monospace, SFMono-Regular, monospace" }}
      >
        &lt;&gt;
      </span>
      <span className="flex flex-col leading-none">
        <span
          className={`whitespace-nowrap font-display text-xl font-bold tracking-tight md:text-[26px] ${wordPrimary}`}
        >
          Contentium <span className="text-[#737373]">Tech</span>
        </span>
        {showTagline && (
          <span
            className={`mt-1.5 whitespace-nowrap text-[10px] font-semibold uppercase tracking-[0.22em] md:text-[11px] ${taglineColor}`}
          >
            Content. Powered by Technology.
          </span>
        )}
      </span>
    </span>
  );
}
